<div
  #canvasHoldersContainer
  class="canvas-holders-container"
  (resized)="onResized($event)"
>
  <div class="canvas-holder">
    <canvas #layoutCanvas></canvas>
  </div>
</div>
